import { render } from "./CreateTask.vue?vue&type=template&id=7eb3fadc&scoped=true"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"

import "./CreateTask.vue?vue&type=style&index=0&id=7eb3fadc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb3fadc"]])

export default __exports__